export default "__VITE_ASSET__ByR2xgQz__"